import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Text } from '@catalogo/theme-text';
import { withCookies } from '@catalogo/core-connect/cookies';
import { withDevice } from '@catalogo/core-connect/device';
import ArrowIcon from '@catalogo/ui-americanas-desktop-svg/arrow.svg';
import IconMap from '@catalogo/ui-americanas-desktop-svg/location.svg';
import { withRouter } from 'react-router';
import { replaceUrlParams } from '@catalogo/service-americanas-product/src/helpers/url';
import compose from 'lodash/fp/compose';
import { formatMask } from '../helpers/mask';
import { fetchAddress } from '../services';

const getFormatedAddress = (address, cep) => {
  if (Object.keys(address).length < 1) {
    return formatMask(cep, '00000-000');
  }

  const { address: street, neighborhood, city, state } = address;

  if (!street || !neighborhood) {
    return ` ${city} - ${state}`;
  }
  return `${street}, ${neighborhood} - ${city} - ${state}`;
};

export const Address = ({ cookies, device, history }) => {
  const { persistentCep } = cookies;
  const [address, setAddress] = useState({});

  useEffect(() => {
    if (persistentCep) {
      fetchAddress(persistentCep).then(address => setAddress(address));
    }
  }, [persistentCep]);

  return (
    <Flexbox device={device} onClick={replaceUrlParams(history, '#modal-select-address', false)}>
      <Cell auto>
        <Location fill="inherit" width="18px" height="18px" />
      </Cell>
      <Cell>
        <CepText device={device}>{getFormatedAddress(address, persistentCep)}</CepText>
      </Cell>
      {device === 'mobile' && (
        <Cell auto>
          <ArrowIcon fill="#666" width="12px" height="12px" transform="rotate(270)" />
        </Cell>
      )}
    </Flexbox>
  );
};

const Location = styled(IconMap)`
  fill: ${({ theme }) => theme.grey.dark};

  &:hover {
    fill: ${({ theme }) => theme.primaryColor};
  }
`;

const Flexbox = styled.a`
  display: flex;
  flex-direction: row;
  background-color: transparent;
  padding: ${({ device }) => (device === 'mobile' ? '0 0 15px 0' : '0 0 0')};
  ${({ device }) => device === 'mobile' && 'border-bottom: 1px solid rgba(206, 204, 204, 0.4);'};
  width: 100%;
  color: ${({ theme }) => theme.grey.dark};

  &:hover {
    color: ${({ theme }) => theme.primaryColor};

    & ${Location} {
      fill: ${({ theme }) => theme.primaryColor};
    }
  }
`;

const CepText = styled(Text)`
  cursor: pointer;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin: 0 5px 0 5px;
  text-decoration: ${({ device }) => (device === 'mobile' ? 'none' : 'underline')};
`;

const Cell = styled.div`
  display: flex;
  width: 100%;
  flex: ${({ auto }) => (!auto ? 'auto' : '1 1 0px')};
`;

Address.propTypes = {
  cookies: PropTypes.object,
  device: PropTypes.string,
};

export default compose(withRouter, withDevice, withCookies)(Address);
